import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    type: {
      title: 'Typ',
      type: 'string',
      fieldRequired: true
    },
    minimumRequired: {
      title: 'Wymagane minimum',
      type: 'number',
      fieldRequired: false
    },
    maximum: {
      title: 'Wartość maksymalna',
      type: 'number',
      fieldRequired: false
    },
    parentId: {
      title: 'Identyfikator rodzica',
      type: 'number',
      fieldRequired: false
    },
    stageId: {
      title: 'Identyfikator etapu',
      type: 'number',
      fieldRequired: false
    },
    statusId: {
      title: 'Identyfikator statusu',
      type: 'number',
      fieldRequired: false
    },
    validate: {
      title: 'Walidacja',
      type: 'boolean'
    },
    description: {
      title: 'Opis',
      type: 'string',
      fieldRequired: true
    },
    calculateType: {
      title: 'Rodzaj liczenia',
      type: 'string',
      fieldRequired: true
    },
    autoFunction: {
      title: 'Funkcja automatycznie wyliczająca ocenę dla kryterium',
      type: 'string',
      fieldRequired: false
    },
    formula: {
      title: 'Formuła',
      type: 'string',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
